import { msg } from 'gt-react';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
// fallow-ignore-next-line circular-dependency -- co-located route modules must import the pathless parent; the cycle is EntityQuickFind → routeTree → routes.tsx → this module → route.tsx and already exists for every migrated route.
import { Route as pathlessAuthenticatedRoute, requireAdmin } from '../route';
import { normalizeAiUsageSearch } from './aiUsageSearch';

const AiUsagePage = lazyRouteComponent(
  () => import('./AiUsagePage'),
  'AiUsagePage',
);

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/ai-usage',
  staticData: {
    app: {
      // Gently-internal, gated exactly like /ff_overrides: admin-only with no nav
      // entry, so it never appears in a customer's sidebar or quick search and is
      // reached by URL. Infra cost is not a customer-facing figure.
      access: {
        adminOnly: true,
      },
    },
  },
  component: AiUsagePage,
  // The window, the expanded workflow and which sections are open all live in the URL, so
  // the view is shareable and survives a refresh. Date bounds are UTC, because the proxy
  // buckets its daily spend aggregates by UTC.
  //
  // The rules live in `aiUsageSearch` so they can be tested without the route tree. They
  // never throw: a hand-edited or stale URL degrades field by field rather than being
  // forwarded to a query that would fail.
  validateSearch: normalizeAiUsageSearch,
  loader: () => ({
    crumb: msg('AI Cost', { context: 'page breadcrumb' }),
  }),
  beforeLoad: ({ context }) => {
    requireAdmin({ context });
  },
});
